import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DocumentText } from "iconsax-react";

import MobileLayout from "../../components/MobileLayout";
import { useAuth } from "../../hooks/auth";
import {
  listUserSuggestions,
  UserSuggestion,
} from "../../services/userSuggestionService";

import {
  Body,
  EmptyState,
  Meta,
  SuggestionCard,
  SuggestionDesc,
  SuggestionTitle,
} from "./styles";

function formatDate(iso?: string): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("pt-BR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

const MySuggestions: React.FC = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState<UserSuggestion[]>([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!user?.uid) {
      setItems([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const data = await listUserSuggestions(user.uid);
      setItems(data);
    } catch (error) {
      console.error(error);
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, [user?.uid]);

  useEffect(() => {
    load();
  }, [load]);

  if (!user?.uid) {
    return (
      <MobileLayout headerTitle="Minhas sugestões" headerType="private">
        <Body>
          <EmptyState>
            <DocumentText size={48} color="#6E6A7C" variant="Linear" />
            <h2>Entre na sua conta</h2>
            <p>Faça login para ver as sugestões que você enviou.</p>
          </EmptyState>
        </Body>
      </MobileLayout>
    );
  }

  return (
    <MobileLayout headerTitle="Minhas sugestões" headerType="private">
      <Body>
        {loading && (
          <p style={{ textAlign: "center", color: "#64748B" }}>Carregando...</p>
        )}

        {!loading && items.length === 0 && (
          <EmptyState>
            <DocumentText size={48} color="#6E6A7C" variant="Linear" />
            <h2>Nenhuma sugestão ainda</h2>
            <p>
              Você ainda não enviou sugestões. Que tal contribuir com um novo
              sinal?
            </p>
            <button type="button" onClick={() => navigate("/enviar-sugestao")}>
              Enviar sugestão
            </button>
          </EmptyState>
        )}

        {!loading &&
          items.map((item) => (
            <SuggestionCard key={item.uid}>
              <SuggestionTitle>{item.title}</SuggestionTitle>
              <SuggestionDesc>{item.description}</SuggestionDesc>
              {item.createdAt ? (
                <Meta>{formatDate(item.createdAt)}</Meta>
              ) : null}
            </SuggestionCard>
          ))}
      </Body>
    </MobileLayout>
  );
};

export default MySuggestions;
